import { useEffect, useRef } from 'react';
import './header.css';

/**
 * Cabecera con carrusel. SEO: sólo el primer slide usa <h1>; los demás son <h2 class="h1">
 * (mismo estilo visual) para que la página tenga un único H1.
 */
const Header = () => {
    const bgHeaderImg = '/assets/custom/images/index-background.jpg';
    const carouselRef = useRef(null);

    useEffect(() => {
        let destroyed = false;
        let $carousel;

        const initCarousel = () => {
            const $ = window.jQuery;
            if (!$ || !$.fn.owlCarousel || !carouselRef.current || destroyed) return;
            $carousel = $(carouselRef.current);
            $carousel.owlCarousel({
                loop: true,
                autoplay: true,
                dots: true,
                nav: true,
                navText: ['<span class="fables-iconarrow-left"></span>', '<span class="fables-iconarrow-right"></span>'],
                items: 1,
                // SEO: con loop:true Owl clona los slides y duplicaría el <h1>. Convertimos
                // el h1 de los clones en h2 (mismo estilo con la clase .h1).
                onInitialized: () => {
                    $carousel.find('.owl-item.cloned h1').each(function () {
                        const $h1 = $(this);
                        $h1.replaceWith($('<h2>', { class: 'h1 ' + ($h1.attr('class') || ''), html: $h1.html() }));
                    });
                }
            });
        };

        if (window.jQuery && window.jQuery.fn.owlCarousel) {
            initCarousel();
        } else {
            const interval = setInterval(() => {
                if (window.jQuery && window.jQuery.fn.owlCarousel) {
                    clearInterval(interval);
                    initCarousel();
                }
            }, 100);
            // stop trying after 10s
            setTimeout(() => clearInterval(interval), 10000);
        }

        return () => {
            destroyed = true;
            if ($carousel) $carousel.trigger('destroy.owl.carousel');
        };
    }, []);

    return (
        <div className="fables-header fables-after-overlay overlay-lighter index-traingle bg-rules">
            <div className="hero-bg" style={{backgroundImage: `url(${bgHeaderImg})`}} aria-hidden="true" />
            <div className="container position-relative z-index">
                <div className="row">
                    <div className="col-md-10 col-lg-7 mr-auto index-carousel">
                        <div ref={carouselRef} className="owl-carousel owl-theme nav-0 z-index mt-md-4 mt-xl-5 pt-md-4 pt-xl-5 dots-0 pb-md-5">
                            <div className="pt-0 mt-0 pt-xl-5 mt-xl-5">
                                <h1 className="fables-main-text-color font-weight-bold mb-1">FACTURACIÓN ELECTRÓNICA
                                    <span className="fables-second-text-color"> + CONTABILIDAD</span>
                                </h1>
                                <p className="fables-forth-text-colo mb-3 light-font fables-header-slider-details">
                                    Ofrecemos un software de contabilidad + facturación electrónica listo para su uso.
                                </p>
                                <a href="/facturacion-electronica" className="btn fables-second-background-color fables-second-border-color white-color rounded-0 mr-4 px-3 px-md-4 py-2 bg-hover-transparent fables-second-hover-color">Más información</a>
                            </div>
                            <div className="pt-0 mt-0 pt-xl-5 mt-xl-5">
                                <h2 className="h1 fables-main-text-color font-weight-bold mb-1">DESARROLLO DE SOFTWARE A LA
                                    <span className="fables-second-text-color"> MEDIDA DE SU NEGOCIO</span>
                                </h2>
                                <p className="fables-forth-text-colo mb-3 light-font fables-header-slider-details">
                                    Potenciamos tu visión con soluciones de software personalizadas. Desde aplicaciones móviles innovadoras hasta plataformas web robustas, creamos la tecnología que impulsa tu éxito.
                                </p>
                                <a href="#contactenos" className="btn fables-second-background-color fables-second-border-color white-color rounded-0 mr-4 px-3 px-md-4 py-2 bg-hover-transparent fables-second-hover-color">Contáctenos</a>
                            </div>
                            <div className="pt-0 mt-0 pt-xl-5 mt-xl-5">
                                <h2 className="h1 fables-main-text-color font-weight-bold mb-1">DESARROLLO DE SOFTWARE EN
                                    <span className="fables-second-text-color"> GENERAL CON DRUPAL</span>
                                </h2>
                                <p className="fables-forth-text-colo mb-3 light-font fables-header-slider-details">
                                    Optimiza tu presencia online con potentes sitios web construidos en Drupal. Ofrecemos personalización, escalabilidad y rendimiento excepcionales.
                                </p>
                                <a href="#contactenos" className="btn fables-second-background-color fables-second-border-color white-color rounded-0 mr-4 px-3 px-md-4 py-2 bg-hover-transparent fables-second-hover-color">Contáctenos</a>
                            </div>
                            <div className="pt-0 mt-0 pt-xl-5 mt-xl-5">
                                <h2 className="h1 fables-main-text-color font-weight-bold mb-1">SOLUCIONES INFORMÁTICAS
                                    <span className="fables-second-text-color"> INTEGRADAS</span>
                                </h2>
                                <p className="fables-forth-text-colo mb-3 light-font fables-header-slider-details">
                                    Simplifica tus operaciones con nuestras soluciones informáticas. Automatización, gestión eficiente de datos y sistemas que trabajan en armonía para potenciar tu rendimiento.
                                </p>
                                <a href="#contactenos" className="btn fables-second-background-color fables-second-border-color white-color rounded-0 mr-4 px-3 px-md-4 py-2 bg-hover-transparent fables-second-hover-color">Contáctenos</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <a href="#services" className="hero-scroll-hint" aria-label="Bajar a los servicios"></a>
        </div>
    );
};

export default Header;
